export default __webpack_public_path__ + "static/media/masters-active.5f863156.svg";